
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PageLayout from "@/components/layout/PageLayout";
import SEOHead from "@/components/SEOHead";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "404 - Page Not Found",
    "description": "The requested page could not be found on forkast.",
    "url": `https://forkast.in${location.pathname}`,
    "isPartOf": {
      "@type": "WebSite",
      "name": "forkast",
      "url": "https://forkast.in"
    }
  };

  return (
    <>
      <SEOHead 
        title="404 - Page Not Found | forkast"
        description="We couldn't find the page you're looking for. Return to forkast homepage for family meal planning."
        jsonLd={jsonLd}
      />
      <PageLayout
        title="404 - Page Not Found"
        description="We couldn't find the page you're looking for."
      >
      <div className="flex flex-col items-center justify-center py-12">
        <p className="text-xl text-gray-600 mb-4">Oops! The page you requested doesn't exist.</p>
        <a href="/" className="text-recipe hover:text-recipe-dark underline">
          Return to Home
        </a>
      </div>
    </PageLayout>
    </>
  );
};

export default NotFound;
